import {EnvironmentService} from '@core/environment/environment.service';
import {environment} from '@environments/environment';

function fillEnvironmentServiceProperties(environmentObj: any, environmentService: EnvironmentService): void {
    for (const key in environmentObj) {
        if (environmentObj.hasOwnProperty(key)) {
            environmentService[key] = environmentObj[key];
        }
    }
}

export const EnvironmentServiceFactory = () => {
    // Create env
    const env = new EnvironmentService();

    // Read environment variables from browser window
    const browserWindowEnv = window['__env'];

    if (browserWindowEnv) {
        fillEnvironmentServiceProperties(browserWindowEnv, env);
    } else {
        fillEnvironmentServiceProperties(environment, env);
    }

    return env;
};

export const EnvironmentServiceProvider = {
    provide: EnvironmentService,
    useFactory: EnvironmentServiceFactory
};
